// extracted by mini-css-extract-plugin
export var orderSummary = "_rm-0";
export var showMoreLessButton = "_rm-1";